/* ============================================================
   ARMOR BANDS – Theme JavaScript
   ============================================================ */

'use strict';

/* ---- Sticky Header (hide on scroll-down, slide in on scroll-up) ---- */
(function() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  // Insert a spacer so page content doesn't jump when header goes fixed
  const spacer = document.createElement('div');
  spacer.className = 'site-header-spacer';
  header.parentNode.insertBefore(spacer, header.nextSibling);

  function updateSpacerHeight() {
    spacer.style.height = header.offsetHeight + 'px';
  }
  updateSpacerHeight();
  window.addEventListener('resize', updateSpacerHeight, { passive: true });

  let lastScroll = 0;
  let scrolledDownBy = 0;
  const HIDE_THRESHOLD = 80;
  const SHOW_THRESHOLD = 6;

  window.addEventListener('scroll', () => {
    const current = window.scrollY;
    const delta   = current - lastScroll;

    // Once past the top, make header fixed and show it
    if (current > header.offsetHeight) {
      header.classList.add('is-fixed');
      spacer.style.display = 'block';
    } else {
      header.classList.remove('is-fixed', 'is-hidden');
      spacer.style.display = 'none';
    }

    // Toggle scrolled styling (background/border/shadow)
    header.classList.toggle('is-scrolled', current > 80);

    if (delta > 0) {
      // Scrolling down — accumulate and hide after threshold
      scrolledDownBy += delta;
      if (scrolledDownBy > HIDE_THRESHOLD && current > 200) {
        header.classList.add('is-hidden');
      }
    } else {
      // Scrolling up — show immediately
      scrolledDownBy = 0;
      if (Math.abs(delta) >= SHOW_THRESHOLD || current < 200) {
        header.classList.remove('is-hidden');
      }
    }

    lastScroll = current <= 0 ? 0 : current;
  }, { passive: true });
})();

/* ---- Mobile Menu (Nike-style slide-in) ---- */
(function() {
  const toggle = document.querySelector('.nav-toggle');
  const menu   = document.querySelector('.nav-mobile');

  if (!toggle || !menu) return;

  function openMenu() {
    toggle.setAttribute('aria-expanded', 'true');
    menu.classList.add('is-open');
    document.body.classList.add('nav-is-open');
  }

  function closeMenu() {
    toggle.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
    document.body.classList.remove('nav-is-open');
  }

  function isOpen() {
    return menu.classList.contains('is-open');
  }

  // Toggle button
  toggle.addEventListener('click', function() {
    isOpen() ? closeMenu() : openMenu();
  });

  // Close on backdrop click (area outside the panel)
  menu.addEventListener('click', function(e) {
    if (e.target === menu) closeMenu();
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen()) closeMenu();
  });

  // Close when a nav link is clicked (for same-page anchors)
  menu.querySelectorAll('.nav-mobile__link, .nav-mobile__cta').forEach(function(link) {
    link.addEventListener('click', function() {
      closeMenu();
    });
  });
})();

/* ---- Announcement Banner Dismiss ---- */
(function() {
  const dismiss = document.querySelector('[data-dismiss-announcement]');
  const banner  = document.querySelector('.announcement-bar');

  if (!dismiss || !banner) return;

  dismiss.addEventListener('click', () => {
    banner.style.display = 'none';
    try { sessionStorage.setItem('ab-announcement-dismissed', '1'); } catch(e) {}
  });

  try {
    if (sessionStorage.getItem('ab-announcement-dismissed') === '1') {
      banner.style.display = 'none';
    }
  } catch(e) {}
})();

/* ---- Search Toggle ---- */
(function() {
  const toggle  = document.querySelector('[data-search-toggle]');
  const overlay = document.querySelector('[data-search-overlay]');
  const close   = document.querySelector('[data-search-close]');
  const input   = overlay ? overlay.querySelector('.header-search__input') : null;

  if (!toggle || !overlay) return;

  function openSearch() {
    overlay.classList.add('is-open');
    if (input) setTimeout(function() { input.focus(); }, 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    if (input) input.value = '';
  }

  toggle.addEventListener('click', openSearch);
  if (close) close.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });
})();

/* ---- Community Signup: CTA focus + post-submit message ---- */
(function() {
  if (!document.querySelector('[data-community-signup]')) return;

  // Links to #join (or the legacy #waitlist) jump to the signup module on
  // this page. Links written as "/#join" (e.g. the sitewide announcement
  // bar) also stay on the current page when it has the module.
  document.querySelectorAll('a[href*="#join"], a[href*="#waitlist"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var samePage = link.pathname === window.location.pathname || link.pathname === '/';
      var target   = samePage && document.getElementById(link.hash.slice(1));
      var section  = target && target.closest('[data-community-signup]');
      if (!section) return;
      var input = section.querySelector('input[type="email"]');
      // Prevent the browser's native anchor scroll — it fires asynchronously
      // and steals focus, so the mobile keyboard never opens (focus() called
      // outside a synchronous user-gesture stack = no keyboard).
      e.preventDefault();
      // Focus synchronously inside the user gesture so the mobile keyboard opens.
      if (input) input.focus({ preventScroll: true });
      // Then scroll the section into view without touching focus.
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // After a submit Shopify reloads the page at the form; move focus to the
  // success / error message so screen readers announce it.
  var message = document.querySelector('[data-community-signup] [data-signup-message]');
  if (message) message.focus();
})();

/* Warriors Hero Carousel: see assets/warriors-carousel.js (loaded by that section) */

/* ---- Warriors Carousel (peek-scroll when >3 cards) ---- */
(function () {
  var grid    = document.querySelector('[data-warriors-grid]');
  var prevBtn = document.querySelector('[data-warriors-prev]');
  var nextBtn = document.querySelector('[data-warriors-next]');
  var navWrap = document.querySelector('[data-warriors-nav]');
  if (!grid || !prevBtn || !nextBtn) return;

  var cards = grid.querySelectorAll('.warrior-card');
  var perPage = window.innerWidth < 600 ? 1 : window.innerWidth < 900 ? 2 : 3;

  if (cards.length <= perPage) return;

  navWrap.classList.add('is-active');
  var page  = 0;
  var total = Math.ceil(cards.length / perPage);

  function update() {
    var gap = parseInt(getComputedStyle(grid).columnGap) || 24;
    var w   = cards[0].offsetWidth + gap;
    grid.style.transform = 'translateX(-' + (page * perPage * w) + 'px)';
    prevBtn.disabled = page === 0;
    nextBtn.disabled = page >= total - 1;
  }

  prevBtn.addEventListener('click', function () { if (page > 0) { page--; update(); } });
  nextBtn.addEventListener('click', function () { if (page < total - 1) { page++; update(); } });

  /* Touch swipe */
  var startX = 0;
  grid.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  grid.addEventListener('touchend', function (e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && page < total - 1) { page++; update(); }
      else if (diff < 0 && page > 0) { page--; update(); }
    }
  }, { passive: true });

  update();
})();


/* ============================================================
   Warriors Stories — Section ambient background hover effect
   Reads data-card-image from each story card; on hover, sets
   that URL as the blurred background layer and fades it in.
   On section mouseleave, fades the layer back out.
   ============================================================ */
(function () {
  var section = document.querySelector('[data-stories-section]');
  if (!section) return;

  var bg    = section.querySelector('[data-stories-bg]');
  var bgImg = section.querySelector('[data-stories-bg-img]');
  if (!bg || !bgImg) return;

  var cards   = section.querySelectorAll('.story-card[data-card-image]');
  var leaveTimer = null;

  cards.forEach(function (card) {
    card.addEventListener('mouseenter', function () {
      clearTimeout(leaveTimer);
      var url = card.getAttribute('data-card-image');
      if (!url) return;
      bgImg.style.backgroundImage = 'url(' + url + ')';
      bg.classList.add('is-active');
    });
  });

  section.addEventListener('mouseleave', function () {
    leaveTimer = setTimeout(function () {
      bg.classList.remove('is-active');
    }, 150); /* small delay prevents flash when crossing card gaps */
  });
})();

/* ---- Product Gallery (PDP) ---- */
(function() {
  var gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;
  var slides  = gallery.querySelectorAll('[data-slide]');
  var thumbs  = gallery.querySelectorAll('[data-thumb]');
  var dots    = gallery.querySelectorAll('[data-dot]');
  var prevBtn = gallery.querySelector('[data-gallery-prev]');
  var nextBtn = gallery.querySelector('[data-gallery-next]');
  var total   = slides.length;
  var current = 0;

  function goTo(index) {
    slides[current].classList.remove('pdp-hero__slide--active');
    if (thumbs[current]) thumbs[current].classList.remove('pdp-hero__thumb--active');
    if (dots[current])   dots[current].classList.remove('pdp-hero__dot--active');
    current = ((index % total) + total) % total;
    slides[current].classList.add('pdp-hero__slide--active');
    if (thumbs[current]) thumbs[current].classList.add('pdp-hero__thumb--active');
    if (dots[current])   dots[current].classList.add('pdp-hero__dot--active');
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      goTo(parseInt(thumb.getAttribute('data-thumb'), 10));
    });
  });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goTo(parseInt(dot.getAttribute('data-dot'), 10));
    });
  });

  /* Touch swipe */
  var touchStartX = 0;
  var mainImage = gallery.querySelector('.pdp-hero__main-image');
  if (mainImage) {
    mainImage.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    mainImage.addEventListener('touchend', function(e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 40) goTo(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });
  }
})();

/* ---- PDP ATC Bar: in-flow → fixed after scrolling past (mobile only) ---- */
(function () {
  var MOBILE_BP = 960;

  var bar  = document.querySelector('[data-atc-bar]');
  var hero = document.querySelector('.pdp-hero');
  if (!bar || !hero) return;

  var mq = window.matchMedia('(max-width: ' + MOBILE_BP + 'px)');
  var pinned = false;

  // Measure the bar's bottom edge distance from the document top ONCE,
  // before we ever touch classes or positioning. This value is stable.
  var barBottom = bar.getBoundingClientRect().bottom + window.scrollY;

  // Placeholder: same height as the bar, inserted before it.
  // When bar becomes fixed, placeholder fills the gap so the page
  // never reflows — which is what caused the jitter loop.
  var ph = document.createElement('div');
  ph.setAttribute('aria-hidden', 'true');
  ph.style.cssText = 'pointer-events:none;visibility:hidden;display:none;';
  ph.style.height     = bar.offsetHeight + 'px';
  ph.style.marginTop  = getComputedStyle(bar).marginTop;
  bar.parentNode.insertBefore(ph, bar);

  function pin(shouldPin) {
    if (shouldPin === pinned) return; // guard: no-op if state unchanged
    pinned = shouldPin;
    bar.classList.toggle('is-fixed', pinned);
    hero.classList.toggle('atc-is-fixed', pinned);
    ph.style.display = pinned ? 'block' : 'none';
  }

  function check() {
    if (!mq.matches) { pin(false); return; }
    // Pin when the viewport top has scrolled past the bar's bottom edge.
    pin(window.scrollY > barBottom);
  }

  window.addEventListener('scroll', check, { passive: true });
  check(); // evaluate on load (bar visible → not pinned)

  mq.addEventListener('change', function () {
    if (!mq.matches) pin(false); else check();
  });
})();

/* ---- Cart Count Badge ---- */
(function () {
  var badges = document.querySelectorAll('[data-cart-count]');
  if (!badges.length) return;

  function update(count) {
    badges.forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.classList.add('is-visible');
      } else {
        el.classList.remove('is-visible');
      }
    });
  }

  function fetchCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { update(cart.item_count); })
      .catch(function () { /* silent */ });
  }

  /* Initial load — Liquid already rendered the count, but re-fetch
     to catch any AJAX changes between page-load and hydration */
  fetchCount();

  /* Listen for Shopify's Section Rendering API events (theme cart
     drawers, quick-add, etc.) and custom 'cart:updated' events */
  document.addEventListener('cart:updated', fetchCount);

  /* Intercept fetch calls to /cart/add, /cart/change, /cart/update,
     /cart/clear so the badge updates after any AJAX cart mutation */
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/i.test(url);

    return _fetch.apply(this, args).then(function (response) {
      if (isCartMutation) {
        /* Small delay so Shopify processes the change */
        setTimeout(fetchCount, 300);
      }
      return response;
    });
  };
})();
